import { useOutstandingFilterContext } from 'features/Cards/CardSingle/context/useOutstandingFilterContext'
import { useGetOutstandingFilter } from 'features/Cards/CardSingle/hooks/useOutstandingFilter'
import { useFeatureFlags } from 'features/FeatureFlags'

export const useHighlightOutstandingIcon = () => {
  const flags = useFeatureFlags()
  const { isFilterOn } = useGetOutstandingFilter()
  const {
    isCategoryOutstandingFilterSettingsOn,
    isNoteOutstandingFilterSettingsOn,
    isReceiptOutstandingFilterSettingsOn,
  } = useOutstandingFilterContext()

  return {
    isReceiptIconHighlighted:
      (flags.CorpCardsSettings ? isReceiptOutstandingFilterSettingsOn : true) &&
      isFilterOn,
    isNoteIconHighlighted: isNoteOutstandingFilterSettingsOn && isFilterOn,
    isCategoryIconHighlighted:
      isCategoryOutstandingFilterSettingsOn && isFilterOn,
  }
}
